import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import menuReducer from "./slices/menuSlice";
import adminReducer from "./slices/adminSlice";
import userReducer from "./slices/userSlice";
// import cartReducer from "./slices/cartSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    admin: adminReducer,
    user: userReducer,
    menu: menuReducer,
    // cart: cartReducer,
  },
});

export default store;
